import { Box, Button, Collapse, Divider, SectionHelper, Text, TextButton, Tooltip } from '@wix/design-system';
import { SparklesSmall, StatusCompleteSparkleSmall, UndoSmall } from '@wix/wix-ui-icons-common';
import { StatusCompleteFilledSmall } from '@wix/wix-ui-icons-common/odeditor';
import React, { useCallback, useState } from 'react';
import { dataHooks } from '../../../../../../utils/datahooks';
import { RuleHelperLayout } from '../../../../../rule-layout/rule-helper/rule-helper-layout';
import { ScreenReaderOnlyStatus } from '../screen-reader-only-status';
export const AiNotification = _ref => {
  let {
    fixedCount,
    manualCount,
    onShowMore,
    onApplyAiFixes,
    hasAppliedAiFixes,
    onUndo,
    dataHook,
    texts
  } = _ref;
  const [isApplyLoading, setIsApplyLoading] = useState(false);
  const disclaimerId = 'ai-notification-disclaimer';
  const handleApplyAiFixes = useCallback(async () => {
    if (!onApplyAiFixes || isApplyLoading) {
      return;
    }
    setIsApplyLoading(true);
    try {
      await onApplyAiFixes();
    } finally {
      setIsApplyLoading(false);
    }
  }, [isApplyLoading, onApplyAiFixes]);
  if (!texts) {
    return null;
  }
  const {
    fixedTitle,
    appliedTitle,
    manualTitle,
    showMoreLabel,
    applyLabel,
    undoTooltip,
    aiMistakesText
  } = texts;
  const showUndoButton = !!onUndo && !!undoTooltip;
  const showFixedSection = fixedCount > 0;
  const showApplyButton = fixedCount > 0 && !hasAppliedAiFixes && !!onApplyAiFixes && !!applyLabel;
  if (!showFixedSection && manualCount === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    className: "ai-notification-section-helper-wrapper",
    display: "block",
    position: "relative",
    width: "100%"
  }, /*#__PURE__*/React.createElement("style", null, `
        .ai-notification-section-helper-wrapper [class*="SectionHelper__content"] {
          min-width: 0;
        }
        .ai-notification-section-helper-wrapper [class*="SectionHelper__textContainer"] {
          flex: 1;
          min-width: 0;
          max-width: none;
          width: 100%;
        }
        .ai-notification-section-helper-wrapper [class*="SectionHelper__textContainer"] > [class*="SectionHelper__text"] {
          display: block;
          width: 100%;
        }
      `), showUndoButton && /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    right: 8,
    top: 6,
    zIndex: 1
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: undoTooltip,
    disabled: !undoTooltip,
    size: "small"
  }, /*#__PURE__*/React.createElement(TextButton, {
    "aria-label": undoTooltip,
    dataHook: dataHook ? dataHooks.aiNotificationUndoButton(dataHook) : undefined,
    size: "tiny",
    onClick: onUndo
  }, /*#__PURE__*/React.createElement(Box, {
    color: "D10"
  }, /*#__PURE__*/React.createElement(UndoSmall, null))))), /*#__PURE__*/React.createElement(SectionHelper, {
    dataHook: dataHook,
    size: "small",
    skin: "standard",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1",
    width: "100%"
  }, showFixedSection && /*#__PURE__*/React.createElement(Box, {
    color: "G10",
    gap: "SP1",
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle"
  }, hasAppliedAiFixes ? /*#__PURE__*/React.createElement(StatusCompleteFilledSmall, null) : /*#__PURE__*/React.createElement(StatusCompleteSparkleSmall, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook ? dataHooks.aiNotificationFixedTitle(dataHook) : undefined,
    size: "tiny",
    weight: "bold"
  }, hasAppliedAiFixes && appliedTitle ? appliedTitle(fixedCount) : fixedTitle(fixedCount))), /*#__PURE__*/React.createElement(Collapse, {
    open: showApplyButton
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    "aria-describedby": aiMistakesText ? disclaimerId : undefined,
    dataHook: dataHook ? dataHooks.aiNotificationApplyButton(dataHook) : undefined,
    disabled: isApplyLoading,
    loading: isApplyLoading,
    priority: "primary",
    size: "tiny",
    skin: "standard",
    type: "button",
    onClick: handleApplyAiFixes
  }, applyLabel))))), showFixedSection && manualCount > 0 && /*#__PURE__*/React.createElement(Divider, {
    skin: "standard"
  }), manualCount > 0 && /*#__PURE__*/React.createElement(RuleHelperLayout, null, /*#__PURE__*/React.createElement(Box, {
    color: "B10",
    gap: "SP1",
    verticalAlign: "top"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "center",
    verticalAlign: "middle"
  }, /*#__PURE__*/React.createElement(SparklesSmall, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHook ? dataHooks.aiNotificationManualTitle(dataHook) : undefined,
    size: "tiny",
    weight: "bold"
  }, manualTitle(manualCount)), showMoreLabel && /*#__PURE__*/React.createElement(TextButton, {
    dataHook: dataHook ? dataHooks.aiNotificationShowMoreButton(dataHook) : undefined,
    size: "tiny",
    skin: "dark",
    underline: "always",
    onClick: onShowMore
  }, showMoreLabel))))), aiMistakesText && /*#__PURE__*/React.createElement(ScreenReaderOnlyStatus, {
    dataHook: dataHook ? dataHooks.aiNotificationDisclaimer(dataHook) : undefined,
    id: disclaimerId
  }, aiMistakesText))));
};
//# sourceMappingURL=ai-notification.js.map